import React, { useState, useContext, useEffect } from 'react'
import { useSetState } from 'react-use'
import {
  Form,
  Input,
  DatePicker,
  Space,
  Button,
  InputNumber,
  message,
  Table,
} from 'antd'
import { DISTANCE_SELLING } from '../../consts'
import { ErpClientContext } from '../../services/erp'
import { sleep } from '@guillotinaweb/react-gmi'
const { RangePicker } = DatePicker

const initial = {
  invoiceNumber: '',
  invoiceDate: '',
  amountCountries: [],
}

Object.keys(DISTANCE_SELLING).map((val) =>
  initial.amountCountries.push({
    [val]: 0,
  })
)

function formatCurrency(value) {
  return Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

export default function ImportInvoiceEurotax() {
  const erpService = useContext(ErpClientContext)
  const [state, setState] = useSetState(initial)
  const [loading, setLoading] = useState(false)
  const [importInvoice, setImportInvoice] = useState(false)
  const [columnsTable, setColumnsTable] = useState(null)
  const [data, setData] = useState(null)
  const [facturaDesglosada, setFacturaDesglosada] = useState(false)
  const [dataPaises, setDataPaises] = useState(null)
  const [columnsTablePaises, setColumnsTablePaises] = useState(null)

  const filterColumn = () =>
    Object.keys(DISTANCE_SELLING).map((val) => ({
      text: val,
      value: val,
    }))

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await erpService.getImportedInvoiceEurotax()

    const columnsAlignRight = ['coste_total_factura', 'coste_total_calculado']

    if (res.status_code === 200 && res.data[0]) {
      setColumnsTable(
        Object.keys(res.data[0]).map((column) => ({
          title: column.replace(/_/g, ' ').toUpperCase(),
          dataIndex: column,
          columnKey: column,
          render:
            column === 'id_factura_eurotax'
              ? (id) => <a onClick={() => desgloseFactura(id)}>{id}</a>
              : null,
          sorter:
            column === 'id_factura_eurotax'
              ? (a, b) => a.id_factura_eurotax - b.id_factura_eurotax
              : null,
          filters: column === 'id_pais' ? filterColumn(column) : null,
          onFilter:
            column === 'id_pais'
              ? (value, record) =>
                  record.id_pais.toLowerCase().startsWith(value)
              : null,
          filterSearch: true,
          align: columnsAlignRight.includes(column) ? 'right' : null,
        }))
      )

      const dataColumnsImportedInvoices = res.data.map((dataRes) => {
        return {
          id_factura_eurotax: dataRes.id_factura_eurotax,
          mes_facturacion: dataRes.mes_facturacion,
          coste_total_factura: formatCurrency(dataRes.coste_total_factura),
          coste_total_calculado: formatCurrency(dataRes.coste_total_calculado),
        }
      })

      setData(dataColumnsImportedInvoices)
    }
  }

  async function getDataEurotax() {
    if (state.invoiceNumber === '' || state.invoiceDate === '') {
      message.error('Invoice code and date are required.')
      return
    }

    setLoading(true)

    const res = await erpService.fetch('/orders/@import_invoice_eurotax', {
      method: 'POST',
      body: JSON.stringify({
        invoice_number: state.invoiceNumber,
        invoice_date: state.invoiceDate,
        amount_countries: state.amountCountries,
      }),
    })

    const response = await res.json()

    if (res.status === 200) {
      message.success('Factura importada correctamente')
      await sleep(2000)
      window.location.reload(false)
    } else {
      message.error(response)
    }

    setLoading(false)
  }

  async function desgloseFactura(id) {
    const res = await erpService.fetch('/orders/@get_invoice_eurotax', {
      method: 'POST',
      body: JSON.stringify({
        id_factura_eurotax: id,
      }),
    })

    const response = await res.json()
    if (res.status === 200) {
      console.log(response)
      const columnsAlignRight = ['coste', 'coste_total']

      setColumnsTable(
        Object.keys(response.desglose_factura[0]).map((column) => ({
          title: column.replace(/_/g, ' ').toUpperCase(),
          dataIndex: column,
          columnKey: column,
          filters: column === 'id_pais' ? filterColumn(column) : null,
          onFilter:
            column === 'id_pais'
              ? (value, record) =>
                  record.id_pais.toLowerCase().startsWith(value)
              : null,
          filterSearch: true,
          align: columnsAlignRight.includes(column) ? 'right' : null,
        }))
      )

      const dataColumnsImportedInvoices = response.desglose_factura.map(
        (dataRes) => {
          return {
            id: dataRes.id,
            id_factura_eurotax: dataRes.id_factura_eurotax,
            mes_facturacion: dataRes.mes_facturacion,
            id_pedido: dataRes.id_pedido,
            id_pais: dataRes.id_pais,
            coste: formatCurrency(dataRes.coste),
          }
        }
      )

      setData(dataColumnsImportedInvoices)

      setColumnsTablePaises(
        Object.keys(response.coste_paises[0]).map((column) => ({
          title: column.replace(/_/g, ' ').toUpperCase(),
          dataIndex: column,
          columnKey: column,
          sorter:
            column === 'fecha_factura'
              ? (a, b) => new Date(a.fecha_factura) - new Date(b.fecha_factura)
              : null,
          filters: column === 'id_pais' ? filterColumn(column) : null,
          onFilter:
            column === 'id_pais'
              ? (value, record) =>
                  record.id_pais.toLowerCase().startsWith(value)
              : null,
          filterSearch: true,
          align: columnsAlignRight.includes(column) ? 'right' : null,
        }))
      )

      const dataColumnsPaises = response.coste_paises.map((dataRes) => {
        return {
          pais: DISTANCE_SELLING[dataRes.pais],
          coste_total: formatCurrency(dataRes.coste_total),
        }
      })

      setDataPaises(dataColumnsPaises)
      setFacturaDesglosada(true)
    }
  }

  return (
    <div
      className="container"
      style={{
        backgroundColor: '#fff',
        padding: '30px',
      }}
    >
      <div className="level-left">
        <h2 className="title is-size-5">Import invoice Eurotax</h2>
      </div>
      {importInvoice ? (
        <Form
          name="import_invoice_eurotax"
          style={{ maxWidth: 600, marginTop: '20px' }}
          onFinish={getDataEurotax}
        >
          <div className="field">
            <label className="label">Enter the invoice number:</label>
            <Form.Item
              label="Invoice number"
              value="invoice_number"
              rules={[
                { required: true, message: 'Please input invoice number!' },
              ]}
            >
              <Input
                placeholder="Input invoice number"
                onChange={(e) => {
                  setState({
                    ...state,
                    invoiceNumber: e.target.value,
                  })
                }}
              />
            </Form.Item>
          </div>
          <div className="field">
            <label className="label">Select allocation month:</label>
            <DatePicker
              format={'MM/YYYY'}
              onChange={(date) => {
                setState({
                  ...state,
                  invoiceDate: `${
                    date._d.getMonth() + 1
                  }/${date._d.getFullYear()}`,
                })
              }}
              picker="month"
            />
          </div>
          <div className="field">
            <label className="label">
              Enter the amounts of the countries of distance selling:
            </label>
            {state.amountCountries.map((countrie, index) => (
              <Form.Item
                label={`Enter the amount for ${
                  DISTANCE_SELLING[Object.keys(countrie)]
                }`}
                onChange={(e) => {
                  const updatedAmountCountries = [...state.amountCountries]
                  updatedAmountCountries[index] = {
                    [Object.keys(countrie)]: parseFloat(e.target.value),
                  }
                  setState({
                    ...state,
                    amountCountries: updatedAmountCountries,
                  })
                }}
                rules={[{ required: true, message: 'Please enter an amount' }]}
              >
                <InputNumber defaultValue={Object.values(countrie)} />
              </Form.Item>
            ))}
          </div>
          <Space>
            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit
                </Button>
                <Button
                  type="dashed"
                  htmlType="button"
                  onClick={() => window.location.reload(false)}
                >
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Space>
        </Form>
      ) : (
        <div style={{ marginTop: '10px' }}>
          <Space>
            <Button
              type="primary"
              onClick={(e) => {
                setImportInvoice(true)
              }}
            >
              Import Invoice
            </Button>
            {facturaDesglosada ? (
              <Button
                type="dashed"
                htmlType="button"
                onClick={() => window.location.reload(false)}
              >
                Reset
              </Button>
            ) : null}
          </Space>
        </div>
      )}
      {importInvoice ? null : (
        <div>
          {facturaDesglosada ? (
            <div className="field" style={{ 'margin-top': '10px' }}>
              <label className="label">Invoice information</label>
              <div style={{ margin: '20px' }}>
                <Table
                  columns={columnsTablePaises}
                  dataSource={dataPaises}
                  bordered
                  sticky
                  scroll={{
                    x: true,
                    y: true,
                  }}
                  size="small"
                  pagination={false}
                />
              </div>
            </div>
          ) : null}
          <div style={{ 'margin-top': '10px' }}>
            <Table
              columns={columnsTable}
              dataSource={data}
              bordered
              sticky
              scroll={{
                x: true,
                y: true,
              }}
              size="small"
              pagination={false}
            />
          </div>
        </div>
      )}
    </div>
  )
}
